module.exports = __webpack_public_path__ + "img/9.098fa7ab.png";